<app-packaging-navigation [itemId]="packagingUnit.id" [callerLevelId]="packagingPartType"
  [callerTypeId]="packagingUnit.packagingTypeId" [currentDirectoryId]="packagingUnit.directoryId" [brandName]="packagingUnit.brandName"
  [productName]="packagingUnit.productName" [articleNumber]="packagingUnit.articleNumber"
  [versionId]="packagingUnit.version" [isCurrentVersion]="packagingUnit.isCurrentVersion"
  [hasRecyclabilityResult]="packagingUnit.hasRecyclabilityResult" [hasLifeCycleResult]="packagingUnit.hasLifeCycleResult"
  [creationTimestamp]="packagingUnit.creationTimestamp">

  <mat-tab-group dynamicHeight>
    <mat-tab [label]="'analysis.expenseCalculation.licenseFee.title' | translate">
      <div class="tab-container">
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFee' | translate"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.ecomodulation' | translate"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFeeVsEcomodulation' | translate"></p>
        <app-expense-calculation-html-template [expenseResults]="expenseResults" [displayType]="DisplayType.licenseFee" [packagingPart]="packagingUnit"
          [packagingPartType]="packagingPartType" [title]="'analysis.expenseCalculation.licenseFee.title' | translate"
          [licenseFeeCountries]="licenseFeeCountries" [ecomodulationCountries]="ecomodulationCountries" [plasticTaxCountries]="plasticTaxCountries"
          disclaimer="{{ 'analysis.expenseCalculation.licenseFee.disclaimer' | translate }}">
        </app-expense-calculation-html-template>
      </div>
    </mat-tab>

    <mat-tab [label]="'analysis.expenseCalculation.plasticTax.title' | translate">
      <div class="tab-container">
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.plasticTax'| translate"></p>
        <app-expense-calculation-html-template [expenseResults]="expenseResults" [displayType]="DisplayType.plasticTax" [packagingPart]="packagingUnit"
          [packagingPartType]="packagingPartType" [title]="'analysis.expenseCalculation.plasticTax.title' | translate"
          [licenseFeeCountries]="licenseFeeCountries" [ecomodulationCountries]="ecomodulationCountries" [plasticTaxCountries]="plasticTaxCountries">
        </app-expense-calculation-html-template>
      </div>
    </mat-tab>

    <mat-tab [label]="'analysis.expenseCalculation.total.title' | translate">
      <div class="tab-container">
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFee' | translate"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.ecomodulation' | translate"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFeeVsEcomodulation' | translate"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.plasticTax'| translate"></p>
        <app-expense-calculation-html-template [expenseResults]="expenseResults" [displayType]="DisplayType.total" [packagingPart]="packagingUnit"
          [packagingPartType]="packagingPartType" [title]="'analysis.expenseCalculation.total.title' | translate"
          [licenseFeeCountries]="licenseFeeCountries" [ecomodulationCountries]="ecomodulationCountries" [plasticTaxCountries]="plasticTaxCountries"
          disclaimer="{{ 'analysis.expenseCalculation.total.disclaimer' | translate }}">
        </app-expense-calculation-html-template>
      </div>
    </mat-tab>
  </mat-tab-group>



</app-packaging-navigation>
